<div class="relative flex flex-row h-full w-full" aria-labelledby="contact-support-modal-title" role="dialog"
    aria-modal="true">
    <div
        class="absolute inset-0 z-10 overflow-hidden bg-zinc-200/40 dark:bg-zinc-900/60 backdrop-blur-md flex items-center justify-center">

        <button type="button" (click)="closeModal()"
            class="absolute top-2 left-2 z-20 rounded-full bg-zinc-200 dark:bg-zinc-600 p-1.5 sm:p-2 text-primary shadow-sm hover:bg-zinc-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-600">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-5 sm:size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>

        </button>

        <div class="relative w-[90%] h-[90%] primary-card-container flex flex-col overflow-hidden p-2 gap-y-2">
            <div aria-hidden="true" class="absolute inset-x-0 transform-gpu overflow-hidden blur-3xl sm:-top-80">
                <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                    class="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]">
                </div>
            </div>

            <div class="shrink-0 z-10 w-full h-full flex flex-col">
                <div
                    class="shrink-0 flex flex-row items-center justify-between w-full border-b border-zinc-200 dark:border-zinc-800 pb-2">
                    <div class="flex items-center">
                        <div class="shrink-0">
                            <div
                                class="size-12 rounded-full bg-gray-50 dark:bg-gray-800 dark:outline dark:-outline-offset-1 dark:outline-white/10 flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-6">
                                    <path
                                        d="m14.479 19.374-.971.939a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5a5.2 5.2 0 0 1-.219 1.49" />
                                    <path d="M15 15h6" />
                                    <path d="M18 12v6" />
                                </svg>
                            </div>
                        </div>
                        <div class="ml-4">
                            <h3 id="contact-support-modal-title"
                                class="text-base font-semibold text-gray-900 dark:text-white">Contact Support</h3>
                            <p class="text-sm text-gray-500 dark:text-gray-400">
                                Email the SHOUT team for billing or account help.
                            </p>
                        </div>
                    </div>
                </div>

                @if (!requestSent()) {
                <div class="flex-1 flex flex-col w-full items-center justify-center">

                    <div class="w-full max-w-4xl grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                        <div class="sm:col-span-6">
                            <label for="support-recipient-email"
                                class="block text-sm/6 font-medium text-gray-900 dark:text-white">Email</label>
                            <div class="mt-2">
                                <input [formField]="requestForm.email" id="support-recipient-email" type="email"
                                    autocomplete="email" placeholder="hello@shoutugc.com"
                                    class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-white/10 dark:placeholder:text-gray-500 dark:focus:outline-primary disabled:cursor-not-allowed disabled:bg-zinc-100 disabled:text-gray-500 dark:disabled:bg-zinc-800/80 dark:disabled:text-gray-400" />
                            </div>
                        </div>

                        <div class="col-span-full">
                            <label for="support-message"
                                class="block text-sm/6 font-medium text-gray-900 dark:text-white">Your
                                message</label>
                            <div class="mt-2">
                                <textarea [formField]="requestForm.message" id="support-message" rows="10"
                                    class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-white/10 dark:placeholder:text-gray-500 dark:focus:outline-primary"></textarea>
                            </div>
                            <p class="mt-3 text-sm/6 text-gray-600 dark:text-gray-400">We include your account details
                                so we can help you faster.</p>
                        </div>

                    </div>

                </div>
                } @else {
                <div class="flex-1 flex flex-col w-full items-center justify-center">
                    <div class="text-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="mx-auto size-12 text-gray-400 dark:text-gray-500">
                            <path d="M20 6 9 17l-5-5" />
                        </svg>

                        <h3 class="mt-2 text-sm font-semibold text-gray-900 dark:text-white">Sent!</h3>
                        <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Your support request has been sent to
                            the SHOUT team.
                        </p>
                        <div class="mt-6">
                            <button (click)="closeModal()" type="button"
                                class="inline-flex items-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-primary/90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:bg-primary dark:shadow-none dark:hover:bg-primary/90 dark:focus-visible:outline-primary">
                                Close
                            </button>
                        </div>
                    </div>

                </div>
                }

                <div
                    class="shrink-0 flex flex-row items-center justify-between w-full border-t border-zinc-200 dark:border-zinc-800 pt-2">
                    <button (click)="closeModal()" type="button"
                        class="secondary-button text-primary inline-flex flex-row items-center">
                        Cancel
                    </button>

                    @if (sendingRequest()) {
                    <span
                        class="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium text-gray-900 inset-ring inset-ring-gray-200 dark:text-white dark:inset-ring-white/10">
                        <svg aria-hidden="true"
                            class="mx-auto w-5 h-5 text-gray-200 animate-spin dark:text-gray-300 fill-primary"
                            viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor" />
                            <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentFill" />
                        </svg>

                        Sending support request…
                    </span>
                    } @else if (requestSent()) {
                    <span
                        class="inline-flex items-center gap-x-1.5 rounded-full bg-green-100 px-2 py-1 text-xs font-medium text-green-700 dark:bg-green-400/10 dark:text-green-400">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 text-green-500 dark:text-green-400">
                            <path d="M20 6 9 17l-5-5" />
                        </svg>
                        Support request sent
                    </span>
                    }
                    @else {
                    <button (click)="sendRequest()" type="button" [disabled]="requestForm().invalid()"
                        class="primary-button inline-flex flex-row items-center gap-x-2 disabled:opacity-60 disabled:cursor-not-allowed">
                        Send support request
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5">
                            <path
                                d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z" />
                            <path d="m21.854 2.147-10.94 10.939" />
                        </svg>
                    </button>
                    }
                </div>
            </div>

            <div aria-hidden="true"
                class="absolute inset-x-0 top-[calc(100%-13rem)] transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]">
                <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                    class="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]">
                </div>
            </div>

        </div>
    </div>
</div>